import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import axios from '../../dataClient/dataClient'
import { billTypeMap } from '../../util/billingConsts'
import { FlexColumn, FlexEndContainer, PaddedForm, StyledDialog, StyledDialogContent } from '../styles/Containers'
import { ErrorMessage, SuccessMessage } from '../common/UserMessage'
import BodyText, { BoldFormTitle } from '../styles/Text'
import Button, { SecondaryButton } from '../common/Button'

function ResendReceiptPopUp({ billId, billType, secondaryBillId, email, open = false, onClose = () => {}, onSuccess = () => {} }) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [hasCompleted, setHasCompleted] = useState(false)

  useEffect(() => {
    if (!open) return

    setError(false)
    setHasCompleted(false)
  }, [open])

  async function handleSend() {
    setIsLoading(true)
    setError(false)

    axios
      .post(`/bill/${billId}/send-receipt`)
      .then(() => {
        setHasCompleted(true)
        onSuccess()
      })
      .catch(e => {
        console.error('Failed to resend receipt', e)
        setError(true)
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <StyledDialog fullWidth open={open} onClose={onClose} keepMounted={false}>
      <StyledDialogContent>
        <PaddedForm>
          <FlexColumn gap="20px">
            <BoldFormTitle>Resend Receipt</BoldFormTitle>
            {hasCompleted ? (
              <FlexColumn gap="20px">
                <SuccessMessage>
                  Receipt for {billTypeMap[billType] || billType} <strong>{secondaryBillId}</strong> successfully resent.
                </SuccessMessage>
              </FlexColumn>
            ) : (
              <FlexColumn gap="20px">
                <BodyText>
                  Are you sure you want to resend the receipt for {billTypeMap[billType] || billType} <strong>{secondaryBillId}</strong> to{' '}
                  <strong>{email}</strong>?
                </BodyText>
                {error && <ErrorMessage>There was an error resending the receipt. Please try again.</ErrorMessage>}
              </FlexColumn>
            )}

            <FlexEndContainer>
              {hasCompleted ? (
                <Button type="button" onClick={onClose}>
                  Close
                </Button>
              ) : (
                <>
                  <SecondaryButton type="button" onClick={onClose} disabled={isLoading}>
                    Cancel
                  </SecondaryButton>
                  <Button type="button" onClick={handleSend} loading={isLoading}>
                    Send
                  </Button>
                </>
              )}
            </FlexEndContainer>
          </FlexColumn>
        </PaddedForm>
      </StyledDialogContent>
    </StyledDialog>
  )
}

ResendReceiptPopUp.propTypes = {
  billId: PropTypes.string.isRequired,
  billType: PropTypes.oneOf(['APPLICATION_FEE', 'FEE_ESTIMATE', 'INVOICE']).isRequired,
  secondaryBillId: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func
}

export default ResendReceiptPopUp
